//
import moment from 'moment'

//
export default {
    /**
     * @description
     * get the align class
     *
     * @param {Object} payload - header definitions
     */
    align: ({ classes, align }) =>
        typeof align === 'string'
            ? [String('text-xs-').concat(String(align)), String(classes)].join(
                  ' '
              )
            : String(classes),

    /**
     * @description
     * get the value to display in table
     *
     * @param {Object} payload - header definitions
     * @param {Any} response - default value to display in table
     */
    header: ({ format, item, options, value }, response) => {
        /**
         * @description
         * remove points and bar from string input
         *
         * @param {Any} val - input value
         */
        const cleanPointAndBar = val =>
            String(val)
                .split('.')
                .join('')
                .split('-')
                .join('')

        /**
         * @description
         * format boolean header value
         *
         * @param {Any} val - header value
         */
        const formatBoolean = val => (val ? 'check' : 'close')

        /**
         * @description
         * format currency header value
         *
         * @param {Any} val - header value
         */
        const formatCurrency = val => {
            //
            let res = ''
            let str = isNaN(val) ? '0' : val
            let num = Number(str).toString()
            let body = num.split('.').shift()
            let last = num.split('.').pop()
            //
            res = String('$ ').concat(splitWithPoint(body))
            //
            if (Number(str) % 1 != 0) {
                res = res.concat(',').concat(last)
            }
            //
            //console.log(Number(str), 'str')
            //
            return res
        }

        /**
         * @description
         * format date header value
         *
         * @param {Any} val - header value
         */
        const formatDate = val => (val ? moment(val).format('DD-MM-YYYY') : '-')

        /**
         * @description
         * format date custom header value
         *
         * @param {Any} val - header value
         */
        const formatDateCustom = (val, opt) =>
            val
                ? moment(val)
                      .lang('es')
                      .format(opt)
                : '-'

        /**
         * @description
         * format date time header value
         *
         * @param {Any} val - header value
         */
        const formatDateTime = val =>
            val ? moment(val).format('DD-MM-YYYY HH:mm') : '-'

        /**
         * @description
         * format date time header value
         *
         * @param {Any} val - header value
         */
        const formatDateTimeDetailed = val =>
            val ? moment(val).format('DD-MM-YYYY HH:mm:ss') : '-'

        /**
         * @description
         * format number header value
         *
         * @param {Any} val - header value
         */
        const formatNumber = val => {
            //
            let res = isNaN(val) ? '0' : val
            let num = Number(val || 0).toString()
            let body = num.split('.').shift()
            let last = num.split('.').pop()
            //
            res = String(body)
            //
            if (Number(val) % 1 != 0) {
                //
                res = res.concat(',').concat(last)
            }
            //
            return res
        }

        const formatNumberWithPoint = val => {
            //
            //val=10002903492340.3
            let res = isNaN(val) ? '0' : val
            let num = Number(val || 0).toString()
            let body = num.split('.').shift()
            let last = num.split('.').pop()
            //
            res = splitWithPoint(cleanPointAndBar(String(body).toString()))
            //
            if (Number(val) % 1 != 0) {
                //
                res = res.concat(',').concat(last)
            }
            //
            return res
            //return 
        }

        /**
         * @description
         * format percentage header value
         *
         * @param {Any} val - header value
         */
        const formatPercentage = val =>
            String(Number(val || 0).toFixed(2)).concat(' %')

        /**
         * @description
         * format rut header value
         *
         * @param {Any} val - header value
         */
        const formatRut = val =>
            [
                splitWithPoint(cleanPointAndBar(val.slice(0, -1).toString())),
                val.slice(-1),
            ].join('-')

        /**
         * @description
         * add point between 3 characters and 1 bar in the end of string
         *
         * @param {String} str - input string value
         */
        const splitWithPoint = str =>
            (
                String(str)
                    .split('')
                    .reverse()
                    .join('')
                    .match(/.{1,3}/g) || []
            )
                .join('.')
                .split('')
                .reverse()
                .join('')

        // get the value from item
        switch (typeof value) {
            case 'function':
                response = value(item)
                break
            case 'string':
                response = item[value]
                break
        }

        // cast and return the header value
        switch (format) {
            case 'boolean':
                return formatBoolean(response)
            case 'currency':
                return formatCurrency(response)
            case 'date':
                return formatDate(response)
            case 'date-custom':
                return formatDateCustom(response, options)
            case 'date-month':
                return formatDateCustom('2000-' + response + '-15', 'MMMM')
            case 'datetime':
                return formatDateTime(response)
            case 'datetime-detailed':
                return formatDateTimeDetailed(response)
            case 'number':
                return formatNumber(response)
            case 'number-point':
                return (Number(response) < 0 ? '-' : '') + formatNumberWithPoint(response)
            case 'number-point-negative':
                return (Number(response) > 0 ? '-' : '') + formatNumberWithPoint(response)
            case 'number-point-positive':
                return (Number(response) > 0 ? '+' : '') + formatNumberWithPoint(response)
            case 'number-point-negative-positive':
                return (Number(response) > 0 ? '+' : Number(response) < 0 ? '-' : '') + formatNumberWithPoint(response)
            case 'percentage':
                return formatPercentage(response)
            case 'rut':
                return formatRut(response)
        }

        // return the header value
        return response
    },

    /**
     * @description
     * get the vue component for the value of header
     *
     * @param {Object} payload - header definitions
     */
    component: ({ type }) => String('v-').concat(String(type)),

    /**
     * @description
     * get the vue component for the input of header
     *
     * @param {Object} payload - header.input definitions
     */
    input: ({ type }) => ['v', String(type || 'text-field')].join('-'),

    /**
     * @description
     * get the vue component for the input items of header with select input type
     *
     * @param {Object} payload - header.input definitions
     */
    inputItems: ({ props, header }) =>
        header.input && header.input.type === 'select'
            ? header.input.renderItems(props)
            : header.input.items,

    /**
     * @description
     * get the vue component for the autocomplete model param filter of header with select input type
     *
     * @param {Object} payload - header.input definitions
     */
    inputFilter: ({ props, header }) =>
        header.input &&
        header.input.type === 'autocomplete-model' &&
        typeof header.input.renderFilter === 'function'
            ? header.input.renderFilter(props)
            : header.input.paramFilter,

    /**
     * @description
     * add point between 3 characters and 1 bar in the end of string
     *
     * @param {Object} payload - header definitions
     */
    type: ({ format }) => (format === 'boolean' ? 'v-icon' : 'span'),
}
